// extracted by mini-css-extract-plugin
export var active = "_8n-b";
export var activeIndicator = "_8n-6";
export var animate = "_8n-a";
export var disabled = "_8n-c";
export var flat = "_8n-1";
export var fullWidth = "_8n-3";
export var lg = "_8n-9";
export var md = "_8n-8";
export var redoButtonTabGroup = "_8n-0";
export var sm = "_8n-7";
export var tabButton = "_8n-4";
export var tabButtonsContainer = "_8n-2";
export var xs = "_8n-5";